module.exports = __webpack_public_path__ + "static/media/css.9bafb49b.svg";